export enum COMMENT_ROUTES {
    GET_COMMENTS = "comments",
    GET_REPLIES = "comments/comment/replies",
    COMMENT = "comments/comment",
    REPLY = "comments/comment/reply"
}